/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Main/theme';

export const MainTheme = theme;
